import { Booking } from '@app/domain/Booking'

export class VoidedBooking {
    constructor(
        public booking: Booking,
        public voidedByUserId: string | null,
        public voidedByUserEmailAddress: string | null
    ) { }
}
